import { Form, Col, Button, Row, message } from 'antd';
import Immutable, { OrderedMap } from 'immutable';
import React from 'react';
import {
    INPUT_TYPES, COMPANY_TYPES,
} from "constants/index";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { CompanyService } from '../../services';
import { Table } from "components";
import moment from 'moment';



const getSupportingDocumentsCredit = () => new OrderedMap({
    download_documents_by_sales: {
        className: "form-field fb-25",
        type: INPUT_TYPES.BUTTON,
        btnType: "link",
        icon: "download",
        shape:"round",
        label: "Download Template",
        placeholder: "",
        viewable: true,
        onClick: () => {
            fetch("https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/company_document/90585/Deviation_Matrix_Template.xlsx")
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = "https://s3.ap-south-1.amazonaws.com/los.progcap.com/media/public/company_document/90585/Deviation_Matrix_Template.xlsx";
                    link.click();
                })
                .catch(console.error);
        },
        // disabled: allFieldsDisabled,
        category: 6
    },
    supporting_documents_by_credit: {
        className: "form-field fb-15",
        type: INPUT_TYPES.FILE,
        accept: ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        viewable: true,
        label: "Upload Deviation Matrix (New)",
        category: 6,
        fileList: [],
        showUploadList: true
    },
});

const DEVIATION_MATRIX_HISTORY = () =>  new OrderedMap({
    create_date: {
        title: "Create Date",
        dataIndex: "create_date",
        key: "create_date",
        width: 40,
        align: "left",
        render : (_) => moment(_).format("DD-MM-YYYY hh:mm a")
    },
    file: {
        title: "File",
        dataIndex: "file",
        key: "file",
        width: 40,
        render: (fileUrl) => (
            <a href={fileUrl} download>Download</a>
        ),
        align: "left"
    },

})


class DeviationMatrixForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);


    onValuesSubmit = () => {
        // e.preventDefault();
        this.props.form.validateFields((err, { users, bank_details, ...restValues }) => {
            if(err){
                return;
            }

            let formDataJson = new FormData();
            const supporting_documents_by_credit = this.props.form.getFieldValue("supporting_documents_by_credit");
            formDataJson.append('file', supporting_documents_by_credit);
            formDataJson.append("company" , this.props.companyId)
            formDataJson.append("document_source" , 3)
            formDataJson.append("mpa_approval_id" , this.props.mpaApprovalId)
            formDataJson.append("document", 95)
            formDataJson.append("fileName", supporting_documents_by_credit.name)

            CompanyService.uploadDocument(this.props.companyId, formDataJson)
            .then((resp) => {
                message.success("File Uploaded");
                this.props.updateDeviationMatrixList();
            })
            .catch((err) => {
                if (err.non_field_errors) {
                    message.error(err.non_field_errors[0]);
                } else {
                    message.error("Something went wrong!");
                }
            })
        })
    };

    
    render() {
        return (
            <div>
                <Row>
                    {
                        getSupportingDocumentsCredit()?.map((field, fieldName) => {
                            const supportingDocumentsByCredit = this.props.form.getFieldValue("supporting_documents_by_credit");
                            let fileListCredit;
                            if (typeof supportingDocumentsByCredit === "string") {
                                if (supportingDocumentsByCredit?.length > 20) {
                                    const firstPart = supportingDocumentsByCredit?.substring(0, 20);
                                    const lastPart = supportingDocumentsByCredit?.substring(supportingDocumentsByCredit?.length - 20);
                                    const shortenedUrl = `${firstPart}...${lastPart}`;
                                    fileListCredit = {
                                        uid: "-1",
                                        name: shortenedUrl,
                                        status: "done",
                                        url: supportingDocumentsByCredit,
                                    };
                                }
                            } else if (typeof supportingDocumentsByCredit === "object") {
                                if (supportingDocumentsByCredit?.name?.length > 20) {
                                    fileListCredit = {
                                        uid: "-1",
                                        name: "",
                                        status: "done",
                                        url: "",
                                    };
                                }
                            }
                            else {
                                console.log("Substring not found");
                            }

                            if (fieldName === "supporting_documents_by_credit" && supportingDocumentsByCredit && typeof supportingDocumentsByCredit === "object") {
                                // field.disabled = true;
                                field.fileList = [];
                                field.showUploadList = false;
                            }
                            if (fieldName === "supporting_documents_by_credit" && supportingDocumentsByCredit && typeof supportingDocumentsByCredit === "string") {
                                // field.disabled = true;
                                field.fileList = [fileListCredit];
                                field.showUploadList = true;
                            }
                           
                            field.disabled = this.props.disableFields;
                            return <Col span="8">{this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )()}</Col>;
                        }).toList()}
                </Row>
                <Row>
                    <Col span="14"></Col>   
                    <Col span="4"><Button  type="link" block disabled={this.props.disableFields} onClick={() => this.onValuesSubmit()}>Upload</Button></Col>
                    <Col span="2"></Col>
                    <Col span="4"><Button type="primary" block disabled={this.props.approveDisabled || this.props.disableFields} onClick={() => this.props.approveDetails()}>Approve</Button></Col>
                </Row>

                <Row className='mt-20'>
                    <h3>Upload History</h3>
                <Table
                        showTopSection={false}
                        
                        pagination={false}
                        noRowSelection={true}
                        size={"small"}
                        columns={DEVIATION_MATRIX_HISTORY()}
                        data={this.props.matrixData}
                    />
                </Row>
            </div>
        )
    }
}


export default Form.create({
    mapPropsToFields: ({ profile, mpaData }) => {
        let mergedRecord = Immutable.Map();
        if (mpaData) {
            mergedRecord = mpaData.merge({ gstin: mpaData.getIn(["company", "gstin"]), name: mpaData.getIn(["company", "name"]), type: mpaData.getIn(["data", "type"]) });
        }
        if (mpaData == null) {
            mergedRecord = mergedRecord.withMutations(record => {
                record
                    .set("name", profile.getIn(["data", "name"]))
                    .set("gstin", profile.getIn(["data", "gstin"]))
                    .set("type", profile.getIn(["data", "type"]));
            });
        }
        return mergedRecord?.map((value, key) => {
            if (key === "approval_date" || key === "ccm_meeting_date") {
                return Form.createFormField({
                    value: value && moment(value)
                });
            }
            if (key === "name") {
                return Form.createFormField({
                    value: profile.getIn(["data", "name"])
                });
            }
            if (key === "gstin") {
                return Form.createFormField({
                    value: profile.getIn(["data", "gstin"])
                });
            }
            if (key === "type") {
                return Form.createFormField({
                    value: COMPANY_TYPES.findKey(_ => _ === profile?.getIn(["data", "type"]))
                });
            }
            if (key === "primary_brand" || key === "industry") {
                return Form.createFormField({
                    value: value?.toJS()
                });
            }
            return Form.createFormField({
                value
            });
        }).toJS();
    }
})(DeviationMatrixForm);